import React, { useEffect, useState } from 'react';
import { Sponsor } from 'app/types';
import { JobfairService } from 'app/services/JobfairService';
import { KTSVG } from '_metronic/helpers';

const SponsorClientInvite: React.FC<{ subdomain: string }> = ({ subdomain }) => {
  const [sponsor, setSponsor] = useState<Sponsor | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSponsor = async () => {
      setIsLoading(true);
      try {
        const jobFairService = new JobfairService();
        const sponsorData = await jobFairService.getJobfairsAndSponsorBySubdomain(subdomain);
        setSponsor(sponsorData.sponsor);
      } catch (err) {
        console.error('Error fetching sponsor:', err);
        setError('Sponsor not found.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSponsor();
  }, [subdomain]);

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center min-vh-100'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!sponsor) {
    return <div>No sponsor data available.</div>;
  }

  return (
    <>
      {/* Hero Section */}
      <div
        className='bgi-no-repeat bgi-size-cover bgi-position-center position-relative mb-10'
        style={{
          backgroundImage: 'url("/media/misc/hero-cover.jpg")',
          height: '320px'
        }}
      >
        <div className='bg-dark position-absolute w-100 h-100'></div>
        <div className='container position-relative'>
          <div className='d-flex flex-column align-items-center justify-content-center min-h-300px text-center'>
            <h1 className='text-white fs-2qx fw-bolder mb-5'>Host your own job fair event  - sponsored by {sponsor?.name}</h1>
            <p>Register as client company and start connecting with top talent.</p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className='container mb-10'>
        <div className='card shadow-sm'>
          <div className='card-body pt-0'>
            <div className='d-flex flex-column align-items-center justify-content-center min-h-300px text-center'>
              <h2 className='text-dark fs-2 fw-bolder mb-5'>Client Company Registration</h2>
              <p className='fs-5 text-muted mb-10'>Join us to create your own video first job fair event(s) and connect with potential candidates.</p>
              <a href={`https://www.videojobfairs.com/auth/registration?sponsorId=${sponsor?.id}`} className='btn btn-primary'>
                <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                Register Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SponsorClientInvite;
